import { Link, useLocation } from "react-router-dom";

const LOGO_URL = "https://custom-images.strikinglycdn.com/res/hrscywv4p/image/upload/c_limit,fl_lossy,h_300,w_300,f_auto,q_auto/17784585/525540_804907.png";

const projectLinks = [
  { name: "Tokeny", url: "https://tokeny.com" },
  { name: "ERC-3643", url: "https://erc3643.org" },
  { name: "T-REX.network", url: "https://t-rex.network" },
  { name: "SupraDapp", url: "https://supradapp.com" },
  { name: "Cableway.Finance", url: "https://cableway.finance" },
  { name: "PassiveCompany", url: "https://passivecompany.ai" },
  { name: "AgentBank", url: "https://agentik.finance" },
];

export default function Footer() {
  const location = useLocation();
  if (location.pathname.startsWith("/admin")) return null;

  return (
    <footer className="bg-slate-50 border-t border-slate-200" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="md:col-span-2">
            <div className="flex items-center gap-3 mb-4">
              <img src={LOGO_URL} alt="SupraLife" className="h-8 w-8" />
              <span className="font-serif text-xl font-bold text-slate-900 tracking-tight">
                SupraLife<span className="text-slate-400 font-normal">.Ventures</span>
              </span>
            </div>
            <p className="font-sans text-sm text-slate-500 leading-relaxed max-w-md mb-6">
              SupraLife.Ventures is a venture studio backed by seasoned entrepreneurs with a track record in web, blockchain, and finance.
            </p>
            <p className="font-mono text-xs text-slate-400 tracking-wider uppercase">
              Building the infrastructure of programmable finance
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="font-mono text-xs tracking-widest uppercase text-slate-400 mb-4">Platform</h4>
            <div className="space-y-2">
              <Link to="/portfolio" className="block font-sans text-sm text-slate-600 hover:text-blue-600 transition-colors">
                Portfolio
              </Link>
              <Link to="/auth" className="block font-sans text-sm text-slate-600 hover:text-blue-600 transition-colors">
                Sign In
              </Link>
              <Link to="/auth?tab=register" className="block font-sans text-sm text-slate-600 hover:text-blue-600 transition-colors">
                Join Us
              </Link>
            </div>
          </div>

          {/* Projects */}
          <div>
            <h4 className="font-mono text-xs tracking-widest uppercase text-slate-400 mb-4">Portfolio</h4>
            <div className="space-y-2">
              {projectLinks.map((p) => (
                <a
                  key={p.name}
                  href={p.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block font-sans text-sm text-slate-600 hover:text-blue-600 transition-colors"
                >
                  {p.name}
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="section-gradient-line mt-12 mb-6"></div>

        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="font-sans text-xs text-slate-400">
            &copy; {new Date().getFullYear()} SupraLife.Ventures. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
